export class UpdatedSchedulesReportParam {
    marketId: number;
    financialCommunityIds: number[];
    changeType: string;
    timeFrame: number;
    masterTaskIds: number[] = [];
    format: string = "EXCELOPENXML";
}